import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Clients from './components/Clients';
import Testimonials from './components/Testimonials';
import ItsOrganic from './components/ItsOrganic';
import Contact from './components/Contact';
import Footer from './components/Footer';
import CursorBlob from './components/CursorBlob';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <div className="App font-body">
      <CursorBlob />
      <Header />
      <Hero />
      <About />
      <Services />
      <Clients />
      <Testimonials />
      <ItsOrganic />
      <Contact />
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;
